/** Must match mobile `AGORA_APP_ID` and backend `AGORA_APP_ID` (token signing). */
export const AGORA_APP_ID = (process.env.REACT_APP_AGORA_APP_ID || "").trim();

export function resolveAgoraAppId(apiAppId) {
  const id = String(apiAppId || AGORA_APP_ID || "").trim();
  if (id.length !== 32) {
    throw new Error("Invalid Agora App ID. Set REACT_APP_AGORA_APP_ID or ensure the API returns appId.");
  }
  return id;
}
